import { Plus } from "lucide-react";
import { usePermissao } from "@/lib/use-permissao";
import { ProsthesisOrdersTable } from "@/components/prosthesis/ProsthesisOrdersTable";
import { useFluxoNovoPedido } from "@/components/prosthesis/FluxoNovoPedido";
import { SemPermissao } from "./SemPermissao";

/** Pedidos de prótese da clínica em foco, com o "Novo pedido" — o fluxo é o mesmo da tela Prótese,
 *  sem o seletor de organização (o pedido sai desta). */
export function PainelProtese() {
  const podeVer = usePermissao("prosthesis.view");
  const podePedir = usePermissao("prosthesis.manage");
  const fluxo = useFluxoNovoPedido();

  if (!podeVer) return <SemPermissao area="os pedidos de prótese" />;
  return (
    <div className="space-y-3">
      {podePedir && (
        <div className="flex justify-end">
          <button
            type="button"
            onClick={fluxo.abrirNovo}
            className="inline-flex h-10 items-center gap-1.5 rounded-md bg-brand-600 px-3 text-[13px] font-semibold text-white shadow-sm transition-colors hover:bg-brand-700"
          >
            <Plus className="h-4 w-4" />
            Novo pedido
          </button>
        </div>
      )}
      <ProsthesisOrdersTable onRequest={fluxo.abrirNovo} onEditar={fluxo.editar} />
      {fluxo.elementos}
    </div>
  );
}
